import { StarCircleIcon } from './StarCircleIcon';

/**
 * author: Google
 * id 76D19C8B-0302-436A-A19F-5AC5EE8AC88C
 * name star-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-circle.svg
 * tags
 * - Shape 
 */
export const FavoriteCircleIcon = StarCircleIcon;
export default FavoriteCircleIcon